<template>
	<div class="upload_img">
		<el-dialog
			:modal-append-to-body="false"
			:title="title"
			:visible.sync="dialogVisible"
			:width="dialogWidth"
			class="upload_cover"
			align="left"
			>
				<div class="upload_dialog_content" style="min-width:600px">
					<div class="upload_dialog_content_oper">
						<el-button  @click="openFile">
							<i class="iconfont">&#xe60f;</i>
							<span style="margin-left: 6px">选择本地图片</span>
						</el-button>
						<el-button @click="changeSuCai">
							<i class="iconfont">&#xe685;</i>
							<span style="margin-left: 6px">选择素材库图片</span>
						</el-button>
					</div>
					<div class="upload_cropper">
						<div class="upload_cropper_con" :style="{'width': cropperW + 'px', 'height': cropperH+ 'px'}">
							<cropper v-if="cropperFlag" :cropperUrl="cropperUrl" :ratio="ratio"
							:fileType="fileType" @coverFinsh="coverFinsh" :cropperW="cropperW" :cropperH="cropperH" @realTime="realTime" ref="cropper" ></cropper>
							<span v-else>选择一张本地图片编辑后上传封面</span>
						</div>
						<div class="cover_preview_con">
							<div class="cover_preview" :style="{'width': cropperW + 'px', 'height': cropperH+ 'px', 'zoom': 0.5}" >
								<img :src="previewObj.url" alt="" v-if="Object.values(previewObj).length" :style="previewObj.img"/>
							</div>
							<span>格式支持{{accept.join('、')}}</span>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sure" :loading="loading" :disabled="!cropperUrl">确 定</el-button>
				</div>
		</el-dialog>
		<div class="upload_con" v-if="conFlag">
			<div class="upload_con_left" :style="{'width': boxW + 'px', 'height': boxH + 'px' }" v-if="value">
				<img :src="value">
				<div class="upload_con_replace">
					<span @click="btnUpload">更换图片</span>
				</div>
			</div>
			<div class="upload_con_left" :style="{'width': boxW + 'px', 'height': boxH + 'px' }" @click="btnUpload" v-else>
				<i class="el-icon-plus"></i>
			</div>
			<div class="upload_con_right" v-if="titFlag">
				<span>1.图片比例{{ratio.join(':')}}</span>
				<span>2.建议尺寸{{size}}</span>
				<span>3.请上传小于{{uploadSize}}的图片</span>
			</div>
		</div>
		<upload-img v-show="false" ref="uploadFile" uploadType="img" :accept="['.jpg','.png','.jpeg']" :autoUpload="false" @beforeUpload="openCropper" :multiple="false" :uploadSize="uploadSize" @uploadSucess="uploadSucess" :isAddSucaiFlag="isAddSucaiFlag1" @uploadError="uploadError" :isCompressFlag="true" :equalRatioNum="equalRatioNum"></upload-img>
		<sucai-dialog v-model="sucaiDialogFlag" uploadType="img" uploadTitle="点击上传本地图片" btnTitle="预览" :accept="['.jpg','.png','.jpeg']" listW="150px" listH="250px" :rowNum="5" :limit="10" :addNumber="0" :isUploadFlag="false" :autoUpload="false" @change="openCropper" :isAddSucaiFlag="isAddSucaiFlag1" @sureClick="sureClick"></sucai-dialog>
	</div>
</template>

<script>
	// import uploader from 'vue-simple-uploader'
	import cropper from '../cropper/cropper.vue'
	// import uploadButton from '../uploadButton/upload_button.vue'
	// import { mapState, mapActions } from 'vuex'
	// import { uploadQiNiuyun } from './upload.js'
	import uploadImg from '../newUpload/upload.vue'
	import SucaiDialog from '../sucaikuDialog/sucaikuDialog.vue'
	export default {
		name: 'Upload',
		// mixins:[uploadQiNiuyun],
		props: {
			boxH: {
				type: [Number,String],
				default: 132
			},
			boxW: {
				type: [Number,String],
				default: 100
			},
			ratio: {
				type: Array,
				default: () => [3, 4]
			},
			size: {
				type: String,
				default: '132*100'
			},
			accept: {
				type: Array,
				default: () => ['.jpg', '.png', '.jpeg', '.tif','.jfif']
			},
			title: {
				type: String,
				default: '上传封面'
			},
			value: {
				type: String,
				default: ''
			},
			id: {
				type: String,
				default: 'uploadFile'
			},
			cropperW: {
				type: [Number, String],
				default: 225
			},
			cropperH: {
				type: [Number, String],
				default: 300
			},
			dialogWidth: {
				type: String,
				default: '600px'
			},
			uploadSize: {
				type: String,
				default: '5mb'
			},
			conFlag: {
				type: Boolean,
				default: true
			},
			isAddSucaiFlag: {
				type: Boolean,
				default: true
			},
			equalRatioNum: {
				type: Number,
				default: 1
			},
			titFlag: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				// attrs: {
				// 	accept: ['.jpg', '.jpeg', '.png']
				// },
				// autoStart: false,
				cropperFlag: false,
				// cropperH: 0,
				// cropperW: 0,
				cropperUrl: '',
				fileType: '',
				// files: {},
				fileName: '',
				blobUrl: '',
				dialogVisible: false,
				previewObj: {},
				sucaiDialogFlag: false,
				fileObj: {},
				loading: false,
				isAddSucaiFlag1: false
			}
		},
		components: {
			cropper,
			// 'upload-button': uploadButton,
			'upload-img': uploadImg,
			'sucai-dialog': SucaiDialog,
			// uploader
		},
		methods: {
			// ...mapActions('uploads',['getUploaderToken', 'getUploadFile']),
			uploadFile() {
				this.dialogVisible = true
				// this.$refs[this.id].$el.click()
			},
			openFile() {
				this.$refs.uploadFile.uploadFile()
			},
			openCropper(list) {
				if(this.isAddSucaiFlag) {
					this.isAddSucaiFlag1 = true
				}
				this.fileObj = list[0]
				var reader = new FileReader()
				let that = this
				reader.onload = function(e) {
					var img = new Image()
					let url = ''
					if (typeof e.target.result === 'object') {
						url = window.URL.createObjectURL(new Blob([e.target.result]));
					} else {
						url = e.target.result;
					}
					img.src = url
					that.cropperUrl = url
					that.cropperFlag = true
				}
				if(!this.fileObj.url) {
					reader.readAsArrayBuffer(list[0].file)
				} else {
					that.cropperUrl = this.fileObj.url
					that.cropperFlag = true
				}
			},
			async coverFinsh(url) {
				const files = new File(
					[url],
					this.fileObj.name, {
						type: url.type
					}
				)
				this.$refs.uploadFile.reloadFile({...this.fileObj, file: files}, 0)

			},
			btnUpload() {
				this.dialogVisible = true
				// this.$refs.uploadFile.$el.click()
			},
			realTime(obj) {
				this.previewObj = obj
			},
			sure() {
				this.loading = true
				this.$refs.cropper.uploadImg()
			},
			changeSuCai() {
				this.sucaiDialogFlag = true
				this.isAddSucaiFlag1 = this.isAddSucaiFlag
			},
			uploadSucess(list) {
				this.dialogVisible = false
				this.loading = false
				if(this.isAddSucaiFlag) {
					this.isAddSucaiFlag1 = false
				}
				let url = list[0].url
				console.log('url1',url)
				if(!url.includes('timestamp=')){
					const randomString = this.randomString(6)
					const t = `&timestamp=${randomString}`
					url += t
				}
				console.log('url2',url)
				this.$emit('input', url)
				this.$emit('change', url)
			},
			sureClick() {
				if(this.isAddSucaiFlag) {
					this.isAddSucaiFlag1 = false
				}
			},
			uploadError() {
				this.loading = false
			},
			randomString(e) {
				e = e || 8;
				var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
					a = t.length,
					n = "";
				for (var i = 0; i < e; i++) {
					n += t.charAt(Math.floor(Math.random() * a))
				}
				return n + Date.now()
			},
		},
		watch: {
			value(news) {
				this.blobUrl = news
			},
			isAddSucaiFlag: {
				immediate: true,
				handler(news) {
					this.isAddSucaiFlag1 = news
				}
			},
			dialogVisible(news) {
				if(news && this.isAddSucaiFlag && !this.cropperUrl) {
					this.isAddSucaiFlag1 = this.isAddSucaiFlag
				}
			}
		}
	}
	
</script>
<style lang="less" scoped>
	.upload_img {
		display: flex;
		.upload_con {
			display: flex;
		}
		.upload_con_left {
			display: flex;
			justify-content: center;
			align-items: center;
			background: #f3f4f9;
			margin-right: 12px;
			border-radius: 8px;
			border: 1px solid #e3e5ee;
			overflow: hidden;
			position: relative;
			img {
				width: 100%;
				height: 100%;
			}
			.el-icon-plus {
				font-size: 28px;
    			color: #c7cada;
			}
			.upload_con_replace {
				background-color: rgba(0,0,0,.49);
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 10;
				display: flex;
				align-items: center;
				justify-content: center;
				transform: translateY(100%);
				transition: all 200ms linear;
				span {
					padding: 9px 15px;
					font-size: 12px;
					border-radius: 3px;
					color: #fff;
					background-color: #4e70f2;
					border-color: #4e70f2;
					line-height: 12px;
					cursor: pointer;
				}
			}
			&:hover {
				.upload_con_replace {
					transform: translateY(0%);
				}
			}
		}

		.upload_con_right {
			position: relative;
			display: flex;
			flex-direction: column;
			font-size: 14px;
			color: #909399;
			line-height: 24px;
			padding: 10px 0;
		}
		.upload_cropper {
			margin-top: 32px;
			display: flex;
			.upload_cropper_con {
				background-color: #f3f4f9;
				border: 1px dashed #c7cada;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				flex-shrink: 0;
				>span {
					width: 132px;
					font-size: 12px;
					color: #999;
					line-height: 17px;
					text-align: center;

				}
			}
			.cover_preview_con {
				margin-left: 40px;
				flex-shrink: 0;
				>span {
					font-size: 12px;
					color: #888a95;
					line-height: 17px;
				}
				.cover_preview {
					background-color: #f3f4f9;
					border: 1px dashed #c7cada;
					overflow: hidden;
					transform-origin: 0 0;
					img {
						width: 100%;
						height: 100%;
					}
				}
			}
			
		}
	}
	// .upload_cover {
	// 	z-index: 1998!important;
	// }
</style>
